export default __webpack_public_path__ + "static/media/waspnest1.c9749492.png";